module.exports = __webpack_public_path__ + "img/css3-alt.4d9b4fb5.svg";